module.exports = __webpack_public_path__ + "static/img/gif.f67700b2.png";